import { CompanyTitledPage } from "../../TitledPage";

import { SAMPLE_TEMPORARY_MARKET_SCHEDULE_LIST } from "../../../common/SampleData";
import { dayWeekToString, getDateString, getYearMonthDateDayDisplay } from "../../../utils/utils";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { Dialog, Grid, OutlinedInput, Radio, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ScheduleConditionApplyDateRangeForm, ScheduleConditionDateForm, ScheduleConditionDayWeekForm, ScheduleConditionHolidayForm, ScheduleConditionMemoForm } from "../../../components/ScheduleConditionSetting";
import { yellow } from "@mui/material/colors";

import { SYSTEM_PATH_COMPANY } from "../../../App";

const collespondTemporaryScheduleToSearchWord = (ts_data, searchWord) => {
  
  if (searchWord === "") {
    return true;
  }

  const {date: dateStr, schedule_type_id: scheduleTypeId, memo: memo} = ts_data;
  const dt = new Date(dateStr);

  const searchableWords = [
    dateStr,
    getYearMonthDateDayDisplay(dt),
    getDateString(dt),
    dayWeekToString(dt.getDay()),
    dayWeekToString(dt.getDay()) + "曜",
    dayWeekToString(dt.getDay()) + "曜日",
    ["臨時休場日", "臨時開場日"][scheduleTypeId],
    memo
  ]

  return searchableWords.some((word) => word.search(searchWord) >= 0);
}

const getTemporarySchedules = (searchCondition) => {

  if (searchCondition && searchCondition.searchWord && searchCondition.searchWord.length > 0) {
    return (
      SAMPLE_TEMPORARY_MARKET_SCHEDULE_LIST
        .filter((ts_data) => collespondTemporaryScheduleToSearchWord(ts_data, searchCondition.searchWord))
    );
  }

  return [...SAMPLE_TEMPORARY_MARKET_SCHEDULE_LIST];

 
}

// 検索フォーム
function TemporaryScheduleSearchForm({searchCondition, setSearchCondition}) {

  // テキストボックス　フォーカス時に全選択する
  const onFocusInput = (event) => {event.target.select()}

  const [searchConditionInput, setSearchConditionInput] = useState(searchCondition);

  const handleChangeSearchCondition
    = (searchProp) => ((event) => {
      setSearchConditionInput({...searchCondition, [searchProp]: event.target.value})
    })

  const onClickSearch = (event) => {
    setSearchCondition(searchConditionInput);
  }

  return (
    <Box border ="1px solid blue" borderRadius={1} padding={2}>
      <Grid container alignItems="center" columnSpacing={2}>
        <Grid item xs="auto">
          フリーワード検索&nbsp;:&nbsp;
          <OutlinedInput
            onFocus={onFocusInput} onChange={handleChangeSearchCondition('searchWord')}
            value={searchConditionInput.searchWord}
            sx={{width:250}}
          />            
        </Grid>
        <Grid item xs />
        <Grid item xs='auto'>
          <Button variant="contained" onClick={onClickSearch}>検索</Button>          
        </Grid>
      </Grid>
    </Box>
  );
}


function TemporaryScheduleRow ({temporaryScheduleData, onClickChangeSetting, onClickDeleteSetting})  {
  const {date: date, schedule_type_id : scheduleTypeId, memo: memo} = temporaryScheduleData;
  
  let scheduleTypeStr = "-";

  if (scheduleTypeId === 1) {
    scheduleTypeStr = "臨時開場日";
  } else if (scheduleTypeId === 0) {
    scheduleTypeStr = "臨時休場日";
  }
  
  return (
    <TableRow>
      <TableCell width="12%">
        {getYearMonthDateDayDisplay(new Date(date))}
      </TableCell>
      <TableCell width="10%">
        {scheduleTypeStr}
      </TableCell>
      <TableCell width="60%">
        {memo}
      </TableCell>
      <TableCell width="8%" sx={{padding: 1}}>
        <Button variant="contained" onClick={onClickChangeSetting}>設定変更</Button>
      </TableCell>
      <TableCell width="8%" sx={{padding: 1}}>
        <Button variant="contained" onClick={onClickDeleteSetting} color="error">設定削除</Button>
      </TableCell>
    </TableRow>
  )
} 

function TemporaryScheduleListTable ({searchCondition, getOnClickChangeSettingFunc, getOnClickDeleteSettingFunc}) {

  const temporarySchedules = getTemporarySchedules(searchCondition);

  return (
    <TableContainer component={Box}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              日付
            </TableCell>
            <TableCell>
              スケジュール種別
            </TableCell>
            <TableCell>
              メモ
            </TableCell>
            <TableCell>
              設定変更
            </TableCell>
            <TableCell>
              設定削除
            </TableCell>
          </TableRow>
          {
            temporarySchedules.map((ts_data) => (
              <TemporaryScheduleRow
                temporaryScheduleData={ts_data}
                key={"ts_" + ts_data.schedule_id}
                onClickChangeSetting={getOnClickChangeSettingFunc(ts_data.schedule_id)}
                onClickDeleteSetting={getOnClickDeleteSettingFunc(ts_data.schedule_id)}
              />
            ))
          }        
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function ScheduleTypeSelectForm({conditionInput, setConditionInput}) {

  const setScheduleTypeSelected = (event) => {
    setConditionInput({...conditionInput, ["schedule_type_id"]: event.target.value});
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs="auto">
        <Radio
          onChange={setScheduleTypeSelected}
          checked={conditionInput.schedule_type_id === "0"}
          value={"0"}
        />
        臨時休場日
      </Grid>
      <Grid item xs="auto">
        <Radio
          onChange={setScheduleTypeSelected}
          checked={conditionInput.schedule_type_id === "1"}
          value={"1"}
        />
        臨時開場日
      </Grid>
       
    </Grid>
  )
}

function TemporaryScheduleConditionSettingDialog({open, onClose, updateTemporaryScheduleCondition, isModeDelete = false}) {

  const [temporaryScheduleConditionInput, setTemporaryScheduleConditionInput] = useState({
    schedule_type_id: "",
    month: "",
    date: "",
    every_month: false,
    week: "",
    certain_week_apply: false,
    day_code: "",
    holiday_apply: true,
    not_holiday_apply: true,
    memo: "",
    apply_start_date: "",
    apply_end_date: ""
  });


  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box padding={2}>
        <Typography fontSize={20} fontWeight={700} marginBottom={2}>臨時スケジュール{isModeDelete ? "削除" : "追加"}</Typography>

        {isModeDelete 
          ? null
          : (
            <Grid container spacing={2} alignItems="center" marginBottom={2}>
              <Grid item xs={3}>
                臨時スケジュール種別
              </Grid>
              <Grid item xs="auto">
                <ScheduleTypeSelectForm
                  conditionInput={temporaryScheduleConditionInput}
                  setConditionInput={setTemporaryScheduleConditionInput}
                />
              </Grid>
            </Grid>
          )
        }
        
        <Grid container spacing={2} alignItems="center" marginBottom={2}>
          <Grid item xs="auto">
            設定範囲
          </Grid>
          <Grid item xs="auto">
            <ScheduleConditionApplyDateRangeForm
              conditionInput={temporaryScheduleConditionInput}
              setConditionInput={setTemporaryScheduleConditionInput}
            />
          </Grid>
        </Grid>
        
        <Box>
          設定条件
          <Box marginLeft={2} marginTop={1}>
            <Grid container spacing={2} alignItems="center" marginBottom={2}>
              <Grid item xs={1}>
                日付 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionDateForm
                  conditionInput={temporaryScheduleConditionInput}
                  setConditionInput={setTemporaryScheduleConditionInput}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}  alignItems="baseline" marginBottom={2}>
              <Grid item xs={1}>
                曜日 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionDayWeekForm
                  conditionInput={temporaryScheduleConditionInput}
                  setConditionInput={setTemporaryScheduleConditionInput}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" marginBottom={2}>
              <Grid item xs={1}>
                祝日 : 
              </Grid>
              <Grid item xs>
                <ScheduleConditionHolidayForm
                  conditionInput={temporaryScheduleConditionInput}
                  setConditionInput={setTemporaryScheduleConditionInput}
                />
              </Grid>
            </Grid>

            {isModeDelete 
              ? null
              : (
                <Grid container spacing={2} alignItems="top" marginBottom={2}>
                  <Grid item xs={1}>
                    メモ : 
                  </Grid>
                  <Grid item xs>
                    <ScheduleConditionMemoForm
                      conditionInput={temporaryScheduleConditionInput}
                      setConditionInput={setTemporaryScheduleConditionInput}
                    />
                  </Grid>
                </Grid>
              )
            }
          </Box>
        </Box>

        <Grid container columnSpacing={1} textAlign="right">
          <Grid item xs>
            <Button variant="contained" color={isModeDelete ? "error" : "primary"} onClick={onClose}>{isModeDelete ? "削除" : "設定"}</Button> 
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClose}>キャンセル</Button> 
          </Grid>           
        </Grid>
      </Box>
    </Dialog>
  )
}

function TemporaryScheduleConditionDeleteDialog({open, onClose, deleteTemporaryScheduleFromCondition}) {
  return (
    <TemporaryScheduleConditionSettingDialog
      open={open} onClose={onClose}
      updateTemporaryScheduleCondition={deleteTemporaryScheduleFromCondition}
      isModeDelete={true}
    />
  )
}

function TemporaryScheduleChangingDialog({open, onClose, scheduleId, updateTemporaryScheduleFromId}) {

  const [temporaryScheduleInput, setTemporaryScheduleInput] = useState({
    schedule_id: null,
    date: "",
    schedule_type_id : "",
    memo: ""
  });

  useEffect(() => {
    if (open) {
      initTemporarySchedule(scheduleId);
    }
  }, [open, scheduleId])

  const initTemporarySchedule = (scheduleId) => {
    const temporarySchedule = SAMPLE_TEMPORARY_MARKET_SCHEDULE_LIST.find((ts_data) => ts_data.schedule_id === scheduleId);

    if (!temporarySchedule) {
      alert("エラーが発生しました。")
      onClose(null);
      return;
    }

    setTemporaryScheduleInput({
      schedule_id: temporarySchedule.schedule_id,
      date: temporarySchedule.date,
      schedule_type_id : temporarySchedule.schedule_type_id.toString(),
      memo: temporarySchedule.memo
    });
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Box padding={2}>
        <Typography fontSize={20} fontWeight={700} marginBottom={2}>臨時スケジュール変更</Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs="auto">
            日付 : 
          </Grid>
          <Grid item xs="auto">
            {getYearMonthDateDayDisplay(new Date(temporaryScheduleInput.date))}
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs="auto">
            臨時スケジュール種別 :
          </Grid>
          <Grid item xs="auto">
            <ScheduleTypeSelectForm
              conditionInput={temporaryScheduleInput}
              setConditionInput={setTemporaryScheduleInput}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} alignItems="top" marginBottom={2}>
          <Grid item xs="auto">
            メモ : 
          </Grid>
          <Grid item xs>
            <ScheduleConditionMemoForm
              conditionInput={temporaryScheduleInput}
              setConditionInput={setTemporaryScheduleInput}
            />
          </Grid> 
        </Grid>

        <Grid container columnSpacing={1} textAlign="right">
          <Grid item xs>
            <Button variant="contained" onClick={onClose}>設定</Button> 
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClose}>キャンセル</Button> 
          </Grid>           
        </Grid>
      </Box>
    </Dialog>
  )
}

function TemporaryScheduleDeleteDialog({open, onClose, scheduleId, deleteTemporaryScheduleFromId}) {

  if (!open) {
    return;
  }

  let temporarySchedule = SAMPLE_TEMPORARY_MARKET_SCHEDULE_LIST.find((ts_data) => ts_data.schedule_id === scheduleId);

  if (open && !temporarySchedule) {
    alert("エラーが発生しました。")
    onClose(null);
    return;
  }

  return(
    <Dialog open={open} onClose={onClose}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>臨時スケジュール削除</Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の臨時スケジュールを削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>日付:&nbsp;{temporarySchedule.date}</Typography>
            <Typography fontSize={20}>臨時スケジュール種別:&nbsp;{["臨時休場日", "臨時開場日"][temporarySchedule.schedule_type_id]}</Typography>
            <Typography fontSize={20}>メモ:&nbsp;{temporarySchedule.memo}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign='center'>
            <Button
              variant="contained"
              color='error'
              onClick={onClose}
            >
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign='center'>
            <Button variant="outlined" onClick={onClose}>戻る</Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}



// 臨時スケジュール一覧ページ
export default function TemporaryScheduleListPage() {

  const navigate = useNavigate();

  const onClickReturnCalendar = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/market_calendar");
  }

  const [searchCondition, setSearchCondition] = useState({
    searchWord: ""
  })
  const [dialogMode, setDialogMode] = useState(0);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);

  const DIALOG_MODE_CODE = {
    close : 0,
    temporary_schedule_condition_set : 1,
    temporary_schedule_condition_delete : 2,
    temporary_schedule_change : 3,
    temporary_schedule_delete : 4,
  };

  const onClickAddSetting = (event) => {
    setSelectedScheduleId(null);
    setDialogMode(DIALOG_MODE_CODE.temporary_schedule_condition_set);
  }

  const onCloseDialog = (event) => {
    setDialogMode(DIALOG_MODE_CODE.close);
  }

  const onClickDeleteSettingCondition = (event) => {
    setSelectedScheduleId(null);
    setDialogMode(DIALOG_MODE_CODE.temporary_schedule_condition_delete);
  }

  const getOnClickChangeSettingFunc = (scheduleId) => ((event) => {
    setSelectedScheduleId(scheduleId);
    setDialogMode(DIALOG_MODE_CODE.temporary_schedule_change);
  })

  const getOnClickDeleteSettingFunc = (scheduleId) => ((event) => {
    setSelectedScheduleId(scheduleId);
    setDialogMode(DIALOG_MODE_CODE.temporary_schedule_delete);
  })

  return (
    <CompanyTitledPage title="臨時スケジュール一覧">
      <Grid container spacing={1} marginBottom={2}>
        <Grid item xs />
        <Grid item xs="auto">
          <Button variant="contained" onClick={onClickAddSetting}>設定追加</Button>
        </Grid>
        <Grid item xs="auto">
          <Button variant="contained" color="error" onClick={onClickDeleteSettingCondition}>設定削除</Button>
        </Grid>
        <Grid item xs="auto">
          <Button variant="contained" onClick={onClickReturnCalendar}>カレンダーに戻る</Button>
        </Grid>
      </Grid>
      <TemporaryScheduleSearchForm searchCondition={searchCondition} setSearchCondition={setSearchCondition} />
      <TemporaryScheduleListTable
        searchCondition={searchCondition}
        getOnClickChangeSettingFunc={getOnClickChangeSettingFunc}
        getOnClickDeleteSettingFunc={getOnClickDeleteSettingFunc}
      />
      <TemporaryScheduleConditionSettingDialog
        open={dialogMode === DIALOG_MODE_CODE.temporary_schedule_condition_set}
        onClose={onCloseDialog}
      />
      <TemporaryScheduleConditionDeleteDialog
        open={dialogMode === DIALOG_MODE_CODE.temporary_schedule_condition_delete}
        onClose={onCloseDialog}
      />
      <TemporaryScheduleChangingDialog
        open={dialogMode === DIALOG_MODE_CODE.temporary_schedule_change}
        onClose={onCloseDialog}
        scheduleId={selectedScheduleId}
      />      
      <TemporaryScheduleDeleteDialog
        open={dialogMode === DIALOG_MODE_CODE.temporary_schedule_delete}
        onClose={onCloseDialog}
        scheduleId={selectedScheduleId}
      />
    </CompanyTitledPage>
  );
}
